<template>
    <answers ref="answers"
             code_question_group="GQ06"
             danger_code="MCAL34"
    >
        <template slot="QCAL070"
                  slot-scope="data"
        >
            {{ data.data.question }}
            <el-popover placement="left"
                        title="Viscosidad cinemática a 40°C (mm2/s)"
                        width="300"
                        trigger="click"
                        popper-class="custom-popover"
            >
                <div v-if="product.properties.kinematic_viscosity"
                     class="mb-2"
                >
                    {{ product.properties.kinematic_viscosity }}
                </div>
                <div v-else
                     class="mb-2"
                >
                    No registra
                </div>
                <div>De acuerdo con el dato de la viscosidad cinemática registrada y la composición del
                    producto, elegir
                    si o no, aplicando el criterio técnico según lo indicado por el Libro del SGA:
                </div>
                <div>
                    NOTA 1: Ejemplos de sustancias clasificadas en la Categoría 1: ciertos hidrocarburos,
                    trementina y
                    aceite de pino.
                </div>
                <div>
                    NOTA 2: En esas condiciones, ciertas autoridades podrán incluir en esta Categoría: los
                    alcoholes
                    n-primarios que tienen entre 3 y 13 átomos de carbono; el alcohol isobutílico y las cetonas
                    con un
                    máximo de 13 átomos de carbono
                </div>
                <span slot="reference"
                      style="cursor: pointer"
                      class="font-weight-bold text-success text-nowrap"
                >
                            <i class="fa fa-info-circle text-success ml-3"/> Ver Viscosidad cinemática
                        </span>
            </el-popover>
        </template>

        <template slot="QCAL071"
                  slot-scope="data"
        >
            {{ data.data.question }}
            <el-popover placement="left"
                        title="Viscosidad cinemática a 40°C (mm2/s)"
                        width="300"
                        trigger="click"
                        popper-class="custom-popover"
            >
                <div v-if="product.properties.kinematic_viscosity"
                     class="mb-2"
                >
                    {{ product.properties.kinematic_viscosity }}
                </div>
                <div v-else
                     class="mb-2"
                >
                    No registra
                </div>
                <div>De acuerdo con el dato de la viscosidad cinemática registrada y la composición del
                    producto, elegir
                    si o no, aplicando el criterio técnico según lo indicado por el Libro del SGA:
                </div>
                <div>
                    NOTA 1: Ejemplos de sustancias clasificadas en la Categoría 1: ciertos hidrocarburos,
                    trementina y
                    aceite de pino.
                </div>
                <div>
                    NOTA 2: En esas condiciones, ciertas autoridades podrán incluir en esta Categoría: los
                    alcoholes
                    n-primarios que tienen entre 3 y 13 átomos de carbono; el alcohol isobutílico y las cetonas
                    con un
                    máximo de 13 átomos de carbono
                </div>
                <span slot="reference"
                      style="cursor: pointer"
                      class="font-weight-bold text-success text-nowrap"
                >
                            <i class="fa fa-info-circle text-success ml-3"/> Ver Viscosidad cinemática
                        </span>
            </el-popover>
        </template>
    </answers>
</template>

<script>
import {mapState} from 'vuex';
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    },
    computed: {
        ...mapState('calculator', ['product'])
    }
};
</script>
